import { StandardShelfCalculator } from './../Standard';
import { IStand } from "./Model/IStand";
import { SurfaceTypesEnum } from '../Standard/Enum/SurfaceTypesEnum'
import { ISelect } from '../Standard/Model/ISelect';

export class SalgoCsavarmentesShelfCalculator extends StandardShelfCalculator {
  // Állványok
  private stands: IStand[] = [];

  constructor(props) {
    super(props);

    this.type = "salgo-csavarmentes";
    this.name = "Salgó csavarmentes polcrendszer tervező - Most 12% kedvezménnyel!";
    this.previewImage = "/images/content/preview/salgo-csavarmentes.jpg";

    this.surfaces = [SurfaceTypesEnum.Horganyzott];
    this.shelfsNumber = [4, 5, 6, 7];
    this.fieldsNumber = [1, 2, 3, 4];

    this.stands = [
      { height: 3000, depth: 800, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 13025}] },
      { height: 3000, depth: 700, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 12384}] },
      { height: 3000, depth: 600, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 11718}] },
      { height: 3000, depth: 500, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 11110}] },
      { height: 3000, depth: 400, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 10737}] },
      { height: 3000, depth: 320, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 10384}] },
      { height: 3000, depth: 250, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 10277}] },
      { height: 2500, depth: 800, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 10467}] },
      { height: 2500, depth: 700, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 10011}] },
      { height: 2500, depth: 600, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 9470}] },
      { height: 2500, depth: 500, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 8991}] },
      { height: 2500, depth: 400, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 8695}] },
      { height: 2500, depth: 320, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 8435}] },
      { height: 2500, depth: 250, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 8620}] },
      { height: 2000, depth: 800, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 8501}] },
      { height: 2000, depth: 700, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 8114}] },
      { height: 2000, depth: 600, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 7677}] },
      { height: 2000, depth: 500, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 7285}] },
      { height: 2000, depth: 400, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 7044}] },
      { height: 2000, depth: 320, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 6826}] },
      { height: 2000, depth: 250, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 6949}] },
      // { height: 1600, depth: 320, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 6133}] },
    ];

    this.shelfs = [
      { width: 1800, depth: 800, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 13813}] },
      { width: 1800, depth: 700, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 12366}] },
      { width: 1800, depth: 600, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 11362}] },
      { width: 1800, depth: 500, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 9835}] },
      { width: 1800, depth: 400, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 8933}] },
      { width: 1800, depth: 320, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 8280}] },
      { width: 1800, depth: 250, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 7705}] },
      { width: 1500, depth: 800, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 9196}] },
      { width: 1500, depth: 700, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 8037}] },
      { width: 1500, depth: 600, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 7196}] },
      { width: 1500, depth: 500, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 5913}] },
      { width: 1500, depth: 400, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 5155}] },
      { width: 1500, depth: 320, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 4607}] },
      { width: 1500, depth: 250, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 4125}] },
      { width: 1200, depth: 800, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 7354}] },
      { width: 1200, depth: 700, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 6479}] },
      { width: 1200, depth: 600, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 5800}] },
      { width: 1200, depth: 500, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 4762}] },
      { width: 1200, depth: 400, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 4150}] },
      { width: 1200, depth: 320, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 3705}] },
      { width: 1200, depth: 250, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 3316}] },
      { width: 900, depth: 800, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 5499}] },
      { width: 900, depth: 700, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 4778}] },
      { width: 900, depth: 600, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 4276}] },
      { width: 900, depth: 500, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 3512}] },
      { width: 900, depth: 400, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 3060}] },
      { width: 900, depth: 320, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 2734}] },
      { width: 900, depth: 250, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 2447}] },
      { width: 600, depth: 800, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 3716}] },
      { width: 600, depth: 700, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 3279}] },
      { width: 600, depth: 600, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 2939}] },
      { width: 600, depth: 500, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 2419}] },
      { width: 600, depth: 400, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 2112}] },
      { width: 600, depth: 320, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 1891}] },
      { width: 600, depth: 250, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 1696}] },
    ];

    this.multiplier = 1.0;

    this.init();

    let heights: number[] = [];
    for (let i = 0; i < this.stands.length; i++) {
      heights.push(this.stands[i].height);
    }
    this.setHeights(heights);
  }

  calculatePrice() {
    this.logger.log("calculatePrice SalgoCsavarmentesShelfCalculator");

    let system = this.getSystem();
    this.logger.log(system);

    let systemPrice = 0;
    let standsNumber = system.fieldsNumber + 1;
    this.logger.log("Állványok száma:", standsNumber);

    let standPrice = this.stands
      .find(currenct => currenct.depth === system.depth && currenct.height === system.height)?.price
      .find(current => current.surface === system.surface)?.price ?? 0;

    this.logger.log("Állvány ára:", standPrice);
    systemPrice += standsNumber * standPrice;

    for (let i = 0; i < system.fieldsNumber; i++) {
      let shelfValue = this.shelfs
        .find(current => current.depth === system.depth && current.width === system.shelfsWidth[i])!.price
        .find(current => current.surface === system.surface)!.price;

      this.logger.log("#" + (i + 1) + " Polc ára:", shelfValue);

      systemPrice += shelfValue * system.shelfsNumber;
    }

    systemPrice *= this.multiplier;

    this.logger.log("Rendszer ára:", systemPrice);

    this.setState({
      netPrice: systemPrice,
      grossPrice: systemPrice * 1.27
    })
  }

  checkShelfsDepth(current: ISelect) {
    const system = this.getSystem();
    const currentDepth = current.value;

    let standPrice = this.stands
      .find(current => current.depth === currentDepth && current.height === system.height)?.price
      .find(current => current.surface === system.surface)?.price ?? 0;

    return standPrice ? true : false;
  }
}

export default SalgoCsavarmentesShelfCalculator;